export interface TreatmentPlanEditModalProps {
  patientId: string;
  source?: string;
}

export const TREATMENT_PLAN_EDIT_DIALOG_DEFAULTS = {
  maxWidth: 'lg' as const,
  fullWidth: true,
  sx: {
    height: { xs: '100%', md: '80vh' },
    maxHeight: { xs: '100%', md: '80vh' },
    bgcolor: 'background.paper',
    boxShadow: 'none',
    border: '1px solid',
    borderColor: 'divider',
    margin: { xs: 0, md: undefined },
    borderRadius: { xs: 0, md: undefined },
  },
};
